/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createOpticheckTask = /* GraphQL */ `
  mutation CreateOpticheckTask($input: CreateOpticheckTaskInput!) {
    createOpticheckTask(input: $input) {
      id
      customer_id
      url
      status
      created
      updated
      check_last
      check_interval_value
      job_last
      check_screenshot
      check_countwords
      check_optimization
    }
  }
`;
export const updateOpticheckTask = /* GraphQL */ `
  mutation UpdateOpticheckTask($input: UpdateOpticheckTaskInput!) {
    updateOpticheckTask(input: $input) {
      id
      customer_id
      url
      status
      created
      updated
      check_last
      check_interval_value
      job_last
      check_screenshot
      check_countwords
      check_optimization
    }
  }
`;
export const deleteOpticheckTask = /* GraphQL */ `
  mutation DeleteOpticheckTask($input: DeleteOpticheckTaskInput!) {
    deleteOpticheckTask(input: $input)
  }
`;
export const createOpticheckOptimization = /* GraphQL */ `
  mutation CreateOpticheckOptimization(
    $input: CreateOpticheckOptimizationInput!
  ) {
    createOpticheckOptimization(input: $input) {
      id
      task_id
      text
    }
  }
`;
export const updateOpticheckOptimization = /* GraphQL */ `
  mutation UpdateOpticheckOptimization(
    $input: UpdateOpticheckOptimizationInput!
  ) {
    updateOpticheckOptimization(input: $input) {
      id
      task_id
      text
    }
  }
`;
export const deleteOpticheckOptimization = /* GraphQL */ `
  mutation DeleteOpticheckOptimization(
    $input: DeleteOpticheckOptimizationInput!
  ) {
    deleteOpticheckOptimization(input: $input)
  }
`;
export const createAdWordsAccount = /* GraphQL */ `
  mutation CreateAdWordsAccount($input: CreateAdWordsAccountInput!) {
    createAdWordsAccount(input: $input) {
      id
      client_id
      status
      created
      updated
    }
  }
`;
export const createAdWordsReportRequest = /* GraphQL */ `
  mutation CreateAdWordsReportRequest(
    $input: CreateAdWordsReportRequestInput!
  ) {
    createAdWordsReportRequest(input: $input) {
      id
      account_id
      start
      end
      status
      created
      updated
      report_data {
        id
        report_id
        KeywordId
        Status
        Criteria
        CampaignId
        CampaignName
        CampaignStatus
        AdGroupId
        AdGroupName
        AccountCurrencyCode
        CpcBid
        Clicks
        Impressions
        Ctr
        AverageCpc
        Cost
        Conversions
        ConversionRate
        CostPerConversion
        SearchImpressionShare
        SearchRankLostImpressionShare
        QualityScore
        SearchPredictedCtr
        PostClickQualityScore
        CreativeQualityScore
        uplift_search_predicted_ctr
        uplift_post_click_quality_score
        uplift_creative_quality_score
        uplift_sum
        predicted_decrease_cpc
        predicted_increase_impressions
        predicted_increase_clicks
        predicted_increase_conversions
      }
    }
  }
`;
export const createToDo = /* GraphQL */ `
  mutation CreateToDo(
    $input: CreateToDoInput!
    $condition: ModelToDoConditionInput
  ) {
    createToDo(input: $input, condition: $condition) {
      id
      title
      description
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const updateToDo = /* GraphQL */ `
  mutation UpdateToDo(
    $input: UpdateToDoInput!
    $condition: ModelToDoConditionInput
  ) {
    updateToDo(input: $input, condition: $condition) {
      id
      title
      description
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const deleteToDo = /* GraphQL */ `
  mutation DeleteToDo(
    $input: DeleteToDoInput!
    $condition: ModelToDoConditionInput
  ) {
    deleteToDo(input: $input, condition: $condition) {
      id
      title
      description
      editors
      createdAt
      updatedAt
      owner
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      user
      email
      groups
      createdAt
      updatedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      user
      email
      groups
      createdAt
      updatedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      user
      email
      groups
      createdAt
      updatedAt
    }
  }
`;
export const createCustomer = /* GraphQL */ `
  mutation CreateCustomer(
    $input: CreateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    createCustomer(input: $input, condition: $condition) {
      id
      name
      active
      contracts {
        id
        name
        active
        customerID
        contacts {
          salutation
          firstName
          lastName
          email
        }
        webmasterReportTasks {
          id
          contractID
          active
          url
          webRiskTaskID
          createdAt
          updatedAt
        }
        webRiskTasks {
          id
          contractID
          active
          url
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      contacts {
        salutation
        firstName
        lastName
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateCustomer = /* GraphQL */ `
  mutation UpdateCustomer(
    $input: UpdateCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    updateCustomer(input: $input, condition: $condition) {
      id
      name
      active
      contracts {
        id
        name
        active
        customerID
        contacts {
          salutation
          firstName
          lastName
          email
        }
        webmasterReportTasks {
          id
          contractID
          active
          url
          webRiskTaskID
          createdAt
          updatedAt
        }
        webRiskTasks {
          id
          contractID
          active
          url
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      contacts {
        salutation
        firstName
        lastName
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteCustomer = /* GraphQL */ `
  mutation DeleteCustomer(
    $input: DeleteCustomerInput!
    $condition: ModelCustomerConditionInput
  ) {
    deleteCustomer(input: $input, condition: $condition) {
      id
      name
      active
      contracts {
        id
        name
        active
        customerID
        contacts {
          salutation
          firstName
          lastName
          email
        }
        webmasterReportTasks {
          id
          contractID
          active
          url
          webRiskTaskID
          createdAt
          updatedAt
        }
        webRiskTasks {
          id
          contractID
          active
          url
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      contacts {
        salutation
        firstName
        lastName
        email
      }
      createdAt
      updatedAt
    }
  }
`;
export const createContract = /* GraphQL */ `
  mutation CreateContract(
    $input: CreateContractInput!
    $condition: ModelContractConditionInput
  ) {
    createContract(input: $input, condition: $condition) {
      id
      name
      active
      customerID
      contacts {
        salutation
        firstName
        lastName
        email
      }
      webmasterReportTasks {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      webRiskTasks {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateContract = /* GraphQL */ `
  mutation UpdateContract(
    $input: UpdateContractInput!
    $condition: ModelContractConditionInput
  ) {
    updateContract(input: $input, condition: $condition) {
      id
      name
      active
      customerID
      contacts {
        salutation
        firstName
        lastName
        email
      }
      webmasterReportTasks {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      webRiskTasks {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteContract = /* GraphQL */ `
  mutation DeleteContract(
    $input: DeleteContractInput!
    $condition: ModelContractConditionInput
  ) {
    deleteContract(input: $input, condition: $condition) {
      id
      name
      active
      customerID
      contacts {
        salutation
        firstName
        lastName
        email
      }
      webmasterReportTasks {
        id
        contractID
        active
        url
        uptimerobot {
          monitorId
        }
        zenkit {
          listShortId
        }
        webRiskTaskID
        createdAt
        updatedAt
      }
      webRiskTasks {
        id
        contractID
        active
        url
        jobsByDate {
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const createWebRiskTask = /* GraphQL */ `
  mutation CreateWebRiskTask(
    $input: CreateWebRiskTaskInput!
    $condition: ModelWebRiskTaskConditionInput
  ) {
    createWebRiskTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      jobsByDate {
        items {
          id
          webRiskTaskID
          date
          urls
          threats
          infected
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateWebRiskTask = /* GraphQL */ `
  mutation UpdateWebRiskTask(
    $input: UpdateWebRiskTaskInput!
    $condition: ModelWebRiskTaskConditionInput
  ) {
    updateWebRiskTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      jobsByDate {
        items {
          id
          webRiskTaskID
          date
          urls
          threats
          infected
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteWebRiskTask = /* GraphQL */ `
  mutation DeleteWebRiskTask(
    $input: DeleteWebRiskTaskInput!
    $condition: ModelWebRiskTaskConditionInput
  ) {
    deleteWebRiskTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      jobsByDate {
        items {
          id
          webRiskTaskID
          date
          urls
          threats
          infected
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const createWebRiskJob = /* GraphQL */ `
  mutation CreateWebRiskJob(
    $input: CreateWebRiskJobInput!
    $condition: ModelWebRiskJobConditionInput
  ) {
    createWebRiskJob(input: $input, condition: $condition) {
      id
      webRiskTaskID
      date
      urls
      threats
      infected
      createdAt
      updatedAt
    }
  }
`;
export const updateWebRiskJob = /* GraphQL */ `
  mutation UpdateWebRiskJob(
    $input: UpdateWebRiskJobInput!
    $condition: ModelWebRiskJobConditionInput
  ) {
    updateWebRiskJob(input: $input, condition: $condition) {
      id
      webRiskTaskID
      date
      urls
      threats
      infected
      createdAt
      updatedAt
    }
  }
`;
export const deleteWebRiskJob = /* GraphQL */ `
  mutation DeleteWebRiskJob(
    $input: DeleteWebRiskJobInput!
    $condition: ModelWebRiskJobConditionInput
  ) {
    deleteWebRiskJob(input: $input, condition: $condition) {
      id
      webRiskTaskID
      date
      urls
      threats
      infected
      createdAt
      updatedAt
    }
  }
`;
export const createWebmasterReportTask = /* GraphQL */ `
  mutation CreateWebmasterReportTask(
    $input: CreateWebmasterReportTaskInput!
    $condition: ModelWebmasterReportTaskConditionInput
  ) {
    createWebmasterReportTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      uptimerobot {
        monitorId
      }
      zenkit {
        listShortId
      }
      webRiskTaskID
      createdAt
      updatedAt
    }
  }
`;
export const updateWebmasterReportTask = /* GraphQL */ `
  mutation UpdateWebmasterReportTask(
    $input: UpdateWebmasterReportTaskInput!
    $condition: ModelWebmasterReportTaskConditionInput
  ) {
    updateWebmasterReportTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      uptimerobot {
        monitorId
      }
      zenkit {
        listShortId
      }
      webRiskTaskID
      createdAt
      updatedAt
    }
  }
`;
export const deleteWebmasterReportTask = /* GraphQL */ `
  mutation DeleteWebmasterReportTask(
    $input: DeleteWebmasterReportTaskInput!
    $condition: ModelWebmasterReportTaskConditionInput
  ) {
    deleteWebmasterReportTask(input: $input, condition: $condition) {
      id
      contractID
      active
      url
      uptimerobot {
        monitorId
      }
      zenkit {
        listShortId
      }
      webRiskTaskID
      createdAt
      updatedAt
    }
  }
`;
export const createWebmasterReportJob = /* GraphQL */ `
  mutation CreateWebmasterReportJob(
    $input: CreateWebmasterReportJobInput!
    $condition: ModelWebmasterReportJobConditionInput
  ) {
    createWebmasterReportJob(input: $input, condition: $condition) {
      id
      webmasterReportTaskID
      readyForSent
      createdAt
      pdf
      expiresAt
      updatedAt
    }
  }
`;
export const updateWebmasterReportJob = /* GraphQL */ `
  mutation UpdateWebmasterReportJob(
    $input: UpdateWebmasterReportJobInput!
    $condition: ModelWebmasterReportJobConditionInput
  ) {
    updateWebmasterReportJob(input: $input, condition: $condition) {
      id
      webmasterReportTaskID
      readyForSent
      createdAt
      pdf
      expiresAt
      updatedAt
    }
  }
`;
export const deleteWebmasterReportJob = /* GraphQL */ `
  mutation DeleteWebmasterReportJob(
    $input: DeleteWebmasterReportJobInput!
    $condition: ModelWebmasterReportJobConditionInput
  ) {
    deleteWebmasterReportJob(input: $input, condition: $condition) {
      id
      webmasterReportTaskID
      readyForSent
      createdAt
      pdf
      expiresAt
      updatedAt
    }
  }
`;
